import { memo, useCallback } from 'react';
import { getCountryRegions } from '../../utils';

export const GuestSelectField = memo(function GuestSelectField({
    fieldName,
    roomIndex,
    guestIndex,
    options,
    guestColumnKey,
    selectValue,
    onRegionMapsUpdate,
    regionMaps,
    onGuestUpdate,
}) {
    const handleChange = useCallback((event) => {
        const newValue = event.target.value;
        onGuestUpdate(roomIndex, guestIndex, guestColumnKey, newValue);

        if (guestColumnKey === 'country' && newValue && regionMaps[newValue] === undefined) {
            getCountryRegions(newValue, { asMap: true }).then((regionsMap) => {
                onRegionMapsUpdate(newValue, regionsMap);
            });
        }
    }, [onGuestUpdate, roomIndex, guestIndex, guestColumnKey, onRegionMapsUpdate, regionMaps]);

    return (
        <select
            name={fieldName}
            value={selectValue ?? ''}
            className="form-control input-sm"
            onChange={handleChange}
        >
            {options.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
        </select>
    );
});
